import { createBrowserRouter } from "react-router-dom";
import Dashboard from "@pages/Dashboard";
import Layout from "../components/Layout";
import Home from "../pages/SignIn";
import NotFound from "../pages/NotFound";
import EmailVerification from "../pages/EmailVerification";
import EmailVerificationSuccess from "../pages/EmailVerificationSuccess";
import ForgetPassword from "../pages/ForgetPassword";
import ResetPassword from "../pages/ResetPassword";
import SignUp from "../pages/SignUp";
import PhoneVerification from "../pages/PhoneVerification";
import MyAccount from "../pages/MyAccount";
import EditMyAccount from "../pages/EditMyAccount";
import SetNewPassword from "../pages/SetNewPassword";
import ChangePassword from "@/pages/ChangePassword";
import RolesAndPermissions from "@/pages/RolesAndPermissions";
import StaffManagement from "@/pages/StaffManagement";
import EditAddRolesAndPermissions from "@/pages/RolesAndPermissions/EditAdd";
import UserManagement from "@/pages/UserManagement";
import RoleAssignedUser from "@/pages/RolesAndPermissions/RoleAssignedUser";
import ProfileManagement from "@/pages/ProfileManagement";
import ProfileAssignedUsers from "@/pages/ProfileManagement/ProfileAssignedUsers";
import AuthRequired from "../components/AuthRequired";
import AuthRedirect from "../components/AuthRedirect";
import TierConfigurationModule from "@/pages/TierConfiguration";
import GeneralMastersLayout from "@/pages/GeneralMasters/Layout";
import TierConfigurationDetails from "@/pages/TierConfiguration/TierConfigurationDetails";
import UserManagementDetails from "@/pages/UserManagement/UserManagementDetails";
import ApprovedOnBoardingDocument from "@/pages/UserManagement/ApprovedOnBoardingDocument";
import CMSPage from "@/pages/CMSPage";
import AddCMSPage from "@/pages/CMSPage/add-cms-page";
import ApprovedOnBoardingDocumentShow from "@/pages/UserManagement/ApprovedOnBoardingDocumentShow";
import ApprovedOnBoardingDocumentChangeHistory from "@/pages/UserManagement/ApprovedOnBoardingDocumentChangeHistory";
import ViewRejectedDocument from "@/pages/UserManagement/UserManagementViewRejectedDocument";
import EditCMSPage from "@/pages/CMSPage/edit-cms-page";
import ClientOnBoarding from "@/pages/ClientOnBoarding";
import AddTierConfiguration from "@/pages/TierConfiguration/AddTierConfiguration";
import EditTierConfiguration from "@/pages/TierConfiguration/EditTierConfiguration";
import ViewTierConfiguration from "@/pages/TierConfiguration/ViewTierConfiguration";
import ToDo from "@/pages/ToDo";
import Contacts from "@/pages/Contacts";
// Auth routes (login, signup, etc.) - redirect if already authenticated
const authRoutes = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/sign-up",
    element: <SignUp />,
  },
  {
    path: "/forget-password",
    element: <ForgetPassword />,
  },
  {
    path: "/reset-password",
    element: <ResetPassword />,
  },
  {
    path: "/email-verification",
    element: <EmailVerification />,
  },
  {
    path: "/email-verification-success",
    element: <EmailVerificationSuccess />,
  },
  {
    path: "/phone-verification",
    element: <PhoneVerification />,
  },
];

// Public routes (accessible to all)
const publicRoutes = [
  {
    path: "*",
    element: <NotFound />,
  },
];

// Protected routes (require authentication)
const protectedRoutes = [
  {
    path: "/dashboard",
    element: <Dashboard />,
  },
  {
    path: "/my-account",
    element: <MyAccount />,
  },
  {
    path: "/edit-my-account",
    element: <EditMyAccount />,
  },
  {
    path: "/change-password",
    element: <ChangePassword />,
  },
  {
    path: "/set-new-password",
    element: <SetNewPassword />,
  },
  {
    path: "/staff-management",
    element: <StaffManagement />,
  },
  {
    path: "/user-management",
    element: <UserManagement />,
  },
  {
    path: "/roles-and-permissions",
    element: <RolesAndPermissions />,
  },
  {
    path: "/edit-add-roles-and-permissions",
    element: <EditAddRolesAndPermissions />,
  },
  {
    path: "/role-assigned-user",
    element: <RoleAssignedUser />,
  },
  {
    path: "/profile-management",
    element: <ProfileManagement />,
  },
  {
    path: "/profile-assigned-users",
    element: <ProfileAssignedUsers />,
  },
  {
    path: "/tier-configuration",
    element: <TierConfigurationModule />,
  },
  {
    path: "/general-masters/*",
    element: <GeneralMastersLayout />,
  },
  {
    path: "/tier-configuration-details",
    element: <TierConfigurationDetails />,
  },
  {
    path: "/user-management-details",
    element: <UserManagementDetails />,
  },
  {
    path: "/approved-on-boarding-document",
    element: <ApprovedOnBoardingDocument />,
  },
  {
    path: "/cms-page",
    element: <CMSPage />,
  },
  {
    path: "/add-cms-page",
    element: <AddCMSPage />,
  },
  {
    path: "/edit-cms-page/:id",
    element: <EditCMSPage />,
  },
  {
    path: "/approved-on-boarding-document-show",
    element: <ApprovedOnBoardingDocumentShow />,
  },
  {
    path: "/approved-on-boarding-document-change-history",
    element: <ApprovedOnBoardingDocumentChangeHistory />,
  },
  {
    path: "/user-management-view-rejected-document",
    element: <ViewRejectedDocument />,
  },
  {
    path: "/client-onboarding",
    element: <ClientOnBoarding />,
  },
  {
    path: "/add-tier-configuration",
    element: <AddTierConfiguration />,
  },
  {
    path: "/edit-tier-configuration",
    element: <EditTierConfiguration />,
  },
  {
    path: "/view-tier-configuration",
    element: <ViewTierConfiguration />,
  },
  {
    path: "/to-do",
    element: <ToDo />,
  },
  {
    path: "/contacts",
    element: <Contacts />,
  },
];

// Router configuration
export const router = createBrowserRouter([
  {
    path: "/",
    element: <Layout />,
    children: [
      // Auth routes wrapped with AuthRedirect
      ...authRoutes.map((route) => ({
        ...route,
        element: <AuthRedirect>{route.element}</AuthRedirect>,
      })),
      // Public routes as-is
      ...publicRoutes,
      // Protected routes wrapped with AuthRequired
      ...protectedRoutes.map((route) => ({
        ...route,
        element: <AuthRequired>{route.element}</AuthRequired>,
      })),
    ],
  },
]);

export default router;
